import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HideFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.14 6.58L6.32 16.38C4.62 15.12 3.24 13.46 2.24 11.96C4.16 9.06 7.52 5.54 12 5.54C13.52 5.54 14.9 5.94 16.14 6.58ZM7.94 17.38L17.74 7.58C19.42 8.84 20.78 10.48 21.76 11.96C19.84 14.86 16.48 18.38 12 18.38C10.52 18.38 9.16 18 7.94 17.38Z" />
    </SvgIcon>
  );
});
